import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { Menu } from '../../shared/menu/menu.model';
import { MenuCategory } from '../../shared/menu/menu-category.model';
import { Observable, Subscription } from 'rxjs';
import { FullMenuService } from '../full-menu.service';

@Component({
  selector: 'app-full-menu-category-container',
  templateUrl: './full-menu-category-container.component.html',
  styleUrls: ['./full-menu-category-container.component.css']
})
export class FullMenuCategoryContainerComponent implements OnInit, OnChanges {

  @Input() menu: Menu;
  @Input() menuName: string;
  @Input() selectedCategory: string;
  selectedMenuOptions: Array<MenuCategory>;
  private selectedMenuOptionsSubscription: Subscription;

  menuTabIndex:number;

  constructor(private fullMenuService: FullMenuService) { }

  ngOnInit() {
    
    this.fetchSelectedMenuOptions();
  }

  ngOnChanges() {
    
    this.fetchSelectedMenuOptions();
  }

  fetchSelectedMenuOptions() {

    this.selectedMenuOptionsSubscription = this.fullMenuService.getCurrentMenuOptions().subscribe( (options: Array<MenuCategory>) => {
      this.selectedMenuOptions = options;
    });
    
    this.fullMenuService.getMenuTabindex().subscribe( (menuTabIndex: number) => {      
      this.menuTabIndex = menuTabIndex;
    })
  }

  ngOnDestroy() {

    this.selectedMenuOptionsSubscription.unsubscribe();
  }

}
